/*
 * File: UIPanelGroup.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Styles a Material UI Expansion Panel in a standardized component.
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PropTypes from "prop-types";

const styles = theme => ({
  heading: {
    padding: 0,
    borderRadius: 20,
    textTransform: "uppercase",
    color: "#777"
  },
  panel: {
    borderRadius: 40,
    border: "1px solid #e8e6e9",
    background: "#efeef4",
    padding: 0,
    paddingRight: 0,
    paddingLeft: 0
  },
  summary: {
    background: theme.palette.common.white
  },
  details: {
    border: 0,
    background: theme.palette.common.white,
    padding: 8,
    borderTop: "1px solid #e8e6e9"
  },
  actions: {
    float: "right"
  }
});

class PatientPanels extends React.Component {
  state = { expanded: false };

  UNSAFE_componentWillMount() {
    let { panels } = this.props;
    for (var idx = 0; idx < panels.length; idx++) {
      let panelId = idx + 1 * 10;
      if (panels[idx].expanded) {
        this.setState({ expanded: panelId });
        break;
      }
    }
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  onClick = parentOnClick => {
    if (typeof parentOnClick === "function") {
      parentOnClick();
    }
  };

  getPanels = () => {
    let { panels, classes, containerClass } = this.props;
    let { expanded } = this.state;

    return panels.map((panel, idx) => {
      // new id so '0' isn't evaluated as a bool
      let panelId = idx + 1 * 10;
      let panelShown = expanded === panelId ? true : false;

      return (
        <div className={containerClass} key={idx}>
          <ExpansionPanel
            className={classes.panel}
            expanded={expanded === panelId}
            onChange={this.handleChange(panelId)}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              className={classes.summary}
            >
              <Typography className={classes.heading}>{panel.title}</Typography>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails className={classes.details}>
              {panel.content(panelShown)}
              {panel.actions && (
                <div>
                  <ExpansionPanelActions className={classes.actions}>
                    ={" "}
                  </ExpansionPanelActions>
                </div>
              )}
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      );
    });
  };

  // -----------------------------------------

  render() {
    let { classes } = this.props;

    return <div className={classes.root}>{this.getPanels()}</div>;
  }
}

PatientPanels.propTypes = {
  panels: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  containerClass: PropTypes.string
};

export default withStyles(styles)(PatientPanels);
